import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';

export const commonDataGridProps = {
    checkboxSelection: true,
    disableRowSelectionOnClick: true,
    sortingOrder: ['desc', 'asc'],
    initialState: {
        sorting: {
            sortModel: [{ field: 'firstName', sort: 'asc' }],
        },
    },
    // pagination: false,
    // Commented For Auth Tab -> IAM-10203

    pageSizeOptions: [25, 50, 100],
    paginationMode: 'server',
    // density: 'standard',
    filterMode: 'server',
};
export const NEW_RESEND_INVITE_USER_DIALOG = 'NEW_RESEND_INVITE_USER_DIALOG';
export const NEW_RESET_PASSWORD_USER_DIALOG = 'NEW_RESET_PASSWORD_USER_DIALOG';
export const NEW_AUTHENTICATION_METHOD_USER_DIALOG = 'NEW_AUTHENTICATION_METHOD_USER_DIALOG';

export const FORM_FIELDS = {
    NAME: 'name',
    DESC: 'description',
    EMAIL: 'email',
};
export const VALIDATION_REGEXP = {
    [FORM_FIELDS.NAME]: new RegExp(/^[ A-Za-z0-9][ A-Za-z0-9:-]*$/),
    [FORM_FIELDS.EMAIL]: new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),
};
export const STATUS = 'status';
export const LOGIN_SCHEME = 'loginScheme';
export const MFA_PROVIDERS = 'mfaProviders';
export const USER_ROLES = 'userRoles';
export const CONNECTED_APPS = 'connectedApps';
export const EMAIL = 'email';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';

export const SINGLE_SELECT = 'singleSelect';

export const EMAIL_MFA = 'Email MFA';
export const AUTH_MFA = 'Auth MFA';
export const DUO_MFA = 'DUO MFA';

export const ACTIVE = 'ACTIVE';
export const PENDING = 'PENDING';
export const EXPIRED = 'EXPIRED';
export const DISABLED = 'DISABLED';

export const NEW_DISABLE_USER_DIALOG = 'NEW_DISABLE_USER_DIALOG';
export const NEW_ENABLE_USER_DIALOG = 'NEW_ENABLE_USER_DIALOG';
export const NEW_DELETE_USERS_DIALOG = 'NEW_DELETE_USERS_DIALOG';
export const DELETE_USERS = 'deleteUsers';
export const DISABLE_USERS = 'disableUsers';
export const EMAIL_IS_VALID = 'IS_VALID';
export const EMAIL_IS_NOT_VALID = 'IS_NOT_VALID';

export const LOCAL_LOGIN = 'Local Login';

export const INFO_AUTHENTICATION_LINK = 'https://docs.connectwise.com/?cid=CW_Home_SSO_Users&psa=1';

const filterOptions = ['isAnyOf'];

export const filterOperators = getGridSingleSelectOperators().filter(item => filterOptions.includes(item.value));

export const ADD_EXTERNAL_IDP = 'ADD_EXTERNAL_IDP';
export const EDIT_EXTERNAL_IDP = 'EDIT_EXTERNAL_IDP';
